import { render, staticRenderFns } from "./BasicProfile.vue?vue&type=template&id=559dd92d&"
import script from "./BasicProfile.vue?vue&type=script&lang=js&"
export * from "./BasicProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports